import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})

export class CreateMessageState{

    allUsers = new BehaviorSubject<any>(null);
    filteredUsers = new BehaviorSubject<any>(null);
    filterOptions = new BehaviorSubject<any>(null);
    selectedUsersIds = new BehaviorSubject<any>([]);

    setAllUsers(users:any){
        this.allUsers.next(users);
    }

    getAllUsers(){
        return this.allUsers;
    }

    setFilteredUsers(users){
        this.filteredUsers.next(users);
    }

    getFilteredUsers$(){
        return this.filteredUsers.asObservable();
    }
    setFiltersOptions(options){
        this.filterOptions.next(options)
    }
    getFilterdOptions$(){
       return this.filterOptions.asObservable() 
    }
    setSelectedUsersId(usersIds){
        this.selectedUsersIds.next(usersIds)
    }
    getSelectedUsersIds$(){
        return this.selectedUsersIds;
    }
    



}